import { FormattedMessage as T } from "react-intl";
import { ContextMenuItem } from "types/common-types";

const OpenLinkInNewTabContextMenuItem = (
  createItemUrl: (id: string) => string
) => {
  return {
    key: "openLinkInNewTab",
    content: <T id="openLinkInNewTab" />,
    onClick: (e: MouseEvent, id: string) => {
      e.stopPropagation();
      window.open(createItemUrl(id), "_blank");
    },
  } as ContextMenuItem;
};

export default OpenLinkInNewTabContextMenuItem;
